<template>
  <div class="relative flex flex-col p-3 pt-1">
    <div class="pb-6 p-2">
      <div class="flex items-center mt-2">
        <div class="text-grey-light-body dark:text-dark-body-text text-xl">
          {{ phase.name }}
        </div>
        <div class="ml-auto dark:text-dark-body-text mr-2 text-2xl items-center flex">
          {{ phase.records_count }}
        </div>
        <div
          :class="[
            `${
              phase.records_count_change
                ? phase.records_count_change > 0
                  ? 'text-green-success'
                  : 'text-red-error'
                : 'text-status-warning-yellow'
            } ${
              phase.records_count_change
                ? phase.records_count_change > 0
                  ? 'bg-green-success'
                  : 'bg-red-error'
                : 'bg-status-warning-yellow'
            }/10 px-2 rounded-full flex items-center`
          ]">
          <ChevronUp
            v-if="phase.records_count_change"
            :color="phase.records_count_change < 0 ? '#F05B5B' : '#27C884'"
            :class="[`${phase.records_count_change < 0 ? 'rotate-180' : ''} h-3 w-3 mr-1`]" />{{ phase.records_count_change }}
        </div>
      </div>
      <div class="mt-4">
        <div
          v-if="$store.state.data.solid_metrics_phases[phase.id]?.filter((stat) => stat.name == `Actual value`).length"
          class="flex my-2">
          <div class="text-common-grey">
            {{ $t("Total Actual Value") }}
          </div>
          <div class="ml-auto text-grey-light-body dark:text-dark-body-text">
            {{ phase.solid_stats.total_actual_value ? `$${$utils.truncateNumber(phase.solid_stats.total_actual_value)}` : "-" }}
          </div>
        </div>
        <div
          v-if="$store.state.data.solid_metrics_phases[phase.id]?.filter((stat) => stat.name == `Forecasted value`).length"
          class="flex my-2">
          <div class="text-common-grey">
            {{ $t("Total Forecasted Value") }}
          </div>
          <div class="ml-auto text-grey-light-body dark:text-dark-body-text">
            {{ phase.solid_stats.total_forecasted_value ? `$${$utils.truncateNumber(phase.solid_stats.total_forecasted_value)}` : "-" }}
          </div>
        </div>
        <div v-for="stats in phase.stats" :key="stats.id" class="flex my-2">
          <div class="text-common-grey">
            {{ stats.name }}
          </div>
          <div class="ml-auto text-grey-light-body dark:text-dark-body-text">
            {{ $utils.isNotEmpty(stats.value) ? $utils.humanizeMetricValue(stats, stats.value) : " - " }}
          </div>
        </div>
      </div>
      <div
        :class="[
          `w-[95%] border-b-2 ${
            phase.records_count_change
              ? phase.records_count_change > 0
                ? 'border-green-success'
                : 'border-red-error'
              : 'border-status-warning-yellow'
          } absolute bottom-5`
        ]" />
    </div>
  </div>
</template>

<script>
import { ChevronUp } from "lucide-vue-next"

export default {
  components: {
    ChevronUp
  },
  props: {
    phase: {
      type: Object,
      default: null
    }
  }
}
</script>
